import { useEffect, useRef, useState } from 'react';
import { usePrevious } from 'react-use';
import { isUndefined } from 'lodash-es';

export function useMergeState<T>(
  initialValue: T,
  options?: { defaultValue?: T; value?: T }
) {
  const { defaultValue, value } = options ?? {};

  const isFirstRender = useRef(true);
  const previousValue = usePrevious(value);

  const [stateValue, setStateValue] = useState<T>(() => {
    return !isUndefined(value) ? value : defaultValue ?? initialValue;
  });

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (isUndefined(value) && previousValue !== value) {
      setStateValue(value as T);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const mergedValue = isUndefined(value) ? stateValue : value;

  return [mergedValue, setStateValue] as const;
}
